module.exports = __webpack_public_path__ + "img/porsche-gt3.8519d427.jpg";